import React from 'react';
import { Radio } from 'src/core/forms';
import classnames from 'classnames';

import { Svg } from '../Svg/Svg';
import { SvgIconNames } from '../Svg/icons-types';

import classes from './CustomRadio.scss';

type Props = {
    id: string;
    value: string;
    title?: string;
    description?: string;
    meta?: React.ReactNode;
    icon?: SvgIconNames;
    isBundleView?: boolean;
    disabled?: boolean;
    descriptionTitle?: string;
    image?: React.ReactNode;
    customStyle?: boolean;
    temporaryClass?: boolean;
    bundleCustom?: boolean;
    isCustomInput?: boolean;
};

export const CustomRadio: React.FC<Props> = (props) => {
    const {
        id,
        value,
        title,
        image,
        description,
        meta,
        icon,
        customStyle,
        isBundleView,
        disabled,
        descriptionTitle,
        bundleCustom,
        isCustomInput,
    } = props;

    return (
        <div
            className={classnames(classes.container, {
                [classes.containerBundle]: isBundleView,
                [classes.containerCustomInput]: isCustomInput,
            })}
        >
            <Radio
                className={classnames(classes.input, { [classes.customInput]: props.temporaryClass })}
                value={value}
                id={id}
                disabled={disabled}
            />
            <label
                className={classnames(classes.label, {
                    [classes.label2]: descriptionTitle,
                    [classes.label_customStyle]: customStyle,
                    [classes.customLabel]: props.temporaryClass,
                })}
                htmlFor={id}
                data-test-id="CustomRadio_label"
                data-status={disabled}
            >
                {isCustomInput && (
                    <img className={classes.checkIcon} src={require('../../svg/check-circle.svg')} alt="check circle" />
                )}
                {isCustomInput && <div className={classes.emptyCircle}></div>}
                <div
                    className={classnames(classes.information, {
                        [classes.information_customStyle]: customStyle,
                    })}
                >
                    {icon && !isCustomInput && <Svg className={classes.icon} name={icon} />}
                    <div className={classes.information_wrapper}>
                        <span className={classes.content}>
                            {title && (
                                <strong
                                    className={classnames(classes.title, {
                                        [classes.titleAlt]: !description,
                                        [classes.titleCustom]: bundleCustom,
                                    })}
                                >
                                    {title}
                                </strong>
                            )}

                            {descriptionTitle && (
                                <span>
                                    <b>{descriptionTitle}</b>
                                </span>
                            )}
                            {description && (
                                <p className={classnames(classes.desc, { [classes.customDesc]: bundleCustom })}>
                                    {description}
                                </p>
                            )}
                        </span>
                    </div>
                    {icon && isCustomInput && <Svg className={classes.icon} name={icon} />}
                </div>

                {meta && (
                    <small
                        className={classnames(classes.meta, {
                            [classes.meta_customStyle]: customStyle,
                        })}
                    >
                        {meta}
                    </small>
                )}
                {image && image}
            </label>
        </div>
    );
};
